export default "__VITE_ASSET__B2fT6AnS__"